// extracted by mini-css-extract-plugin
export default {"heading":"CancelAppointmentModal_heading__CBGb8","buttons":"CancelAppointmentModal_buttons__+8PjS","cancel-button":"CancelAppointmentModal_cancel-button__GjdQN"};